export default {
  login: '/api/v1/login',
  logout: '/api/v1/logout',

  settings: {
    app: '/api/v1/settings/app',
    locale: '/api/v1/settings/locale',
  },

  languages: {
    supported: '/api/v1/languages/supported',
    index: '/api/v1/languages',
  },

  validate: {
    token: '/api/v1/validate/token',
  },
}
